export enum PstnAssignmentStatus {
    Unassigned = "Unassigned",
    UserAssigned = "UserAssigned",
    ConferenceAssigned = "ConferenceAssigned",
    VoiceApplicationAssigned = "VoiceApplicationAssigned",
    ThirdPartyAppAssigned = "ThirdPartyAppAssigned"
}
